import { Button, Form, Input, message } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../../controller/services/auth";
import useFormValidation from "../../../hooks/useFormValid";
import { setLoading } from "../../../redux/slices/common_slice";
import { routePaths } from "../../../routing/routePaths";
import { getApiErrorMessage } from "../../../utils/helper";
import CardWrapper from "./CardWrapper";

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const { formValid, handleValuesChange, formValues } = useFormValidation(form);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onFinish = (values) => {
    dispatch(setLoading(true));
    const payload = {
      email: values.username,
    };
    forgotPassword(payload)
      .then((resp) => {
        navigate(routePaths.verificationCode, {
          state: {
            email: values.username,
          },
        });
      })
      .catch((err) => {
        message.error(getApiErrorMessage(err, t("errors.requestFailed")));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  return (
    <>
      <CardWrapper>
        <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mx-auto select-language-details">
          <a href={routePaths.login} className="back-arrow-btn">
            <img
              alt=""
              className="img-fluid"
              src="/assets/images/icons/back-arrow-with-bg.svg"
            />
          </a>
          <h1>{t("forgotPassword")}</h1>
          <p>{t("forgotPassDesc")}</p>
          <div className="row">
            <div className="col-12 reset-password-form">
              <Form
                className="common-form"
                name="forgot-pass"
                onFinish={onFinish}
                autoComplete="off"
                form={form}
                onValuesChange={handleValuesChange}
              >
                <Form.Item
                  label={false}
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: t("errors.email"),
                    },
                    {
                      pattern:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: t("errors.validEmail"),
                    },
                  ]}
                >
                  <Input
                    prefix={
                      <img
                        alt=""
                        className="img-fluid"
                        src={
                          formValues?.username
                            ? "/assets/images/icons/message-icon-primary.svg"
                            : "/assets/images/icons/message-icon.svg"
                        }
                      />
                    }
                    placeholder={t("enterEmail")}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    className="auth-theme-btn auth-login-btn auth-theme-btn-fix"
                    type="primary"
                    htmlType="submit"
                    disabled={!formValues.username || !formValid}
                  >
                    {t("continue")}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </CardWrapper>
    </>
  );
};

export default ForgotPassword;
